import { ApiClient } from './ApiClient';
import { store } from 'src/redux';
import { onResponse } from 'src/redux/features';
import { byPassUrlsForResponseHandlingToaster } from 'src/constants/url';
import { commonVaribles } from 'src/constants/constVariables';

const apiClient = ApiClient();
const axiosInstance = apiClient.getInstance();
const dispatch = store.dispatch;

export const getHeader = () => {
	return apiClient.getHeader();
};

export const isEmpty = (obj) => {
	for (var key in obj) {
		if (obj.hasOwnProperty(key)) return false;
	}
	return true;
};

//comman function for api call

export const baseApiCall = async (parameter) => {
	let {
		url = '',
		requestBody = {},
		onSuccess = () => {},
		onFailure = () => {},
		errorCall = () => {},
		header = {},
		timeout = null,
		method = commonVaribles.post,
	} = parameter;

	let apiHeader = isEmpty(header) ? getHeader() : header;

	function getResponseToasterSeverity(status) {
		switch (status) {
			case 400:
			case 404:
			case 406:
			case 409:
				return commonVaribles.warning;
			case 500:
				return commonVaribles.error;
			default:
				return commonVaribles.error;
		}
	}

	try {
		const response = await axiosInstance({
			method: method,
			url: url,
			data: requestBody,
			headers: apiHeader,
			timeout: timeout,
		});

		if (response && response.data.status && response.data.status === 200 || response.data.status === 201) {
			if (!byPassUrlsForResponseHandlingToaster.includes(response.config.url)) {
				dispatch(
					onResponse({
						isToaster: true,
						severity: commonVaribles.success,
						message: response.data.message,
					})
				);
			}
			return onSuccess(response);
		} else if (
			response &&
			response.data.status &&
			response.data.status !== 200
		) {
			const ResponseSeverity = getResponseToasterSeverity(response.data.status);
			dispatch(
				onResponse({
					isToaster: true,
					severity: ResponseSeverity,
					message: response.data.message,
				})
			);
			return onFailure(response);
		}
	} catch (error) {
		if (error.response?.data?.status) {
			const ResponseSeverity = getResponseToasterSeverity(
				error.response.data.status
			);
			dispatch(
				onResponse({
					isToaster: true,
					severity: ResponseSeverity,
					message: error.response.data.message,
				})
			);
		} else {
			dispatch(
				onResponse({
					isToaster: true,
					severity: commonVaribles.error,
					message: error.message,
				})
			);
		}
		return errorCall(error);
	}
};
